<p-table
  #dt1
  [value]="initTenants"
  [globalFilterFields]="['name', 'createdAt']"
>
  <ng-template pTemplate="header">
    <tr>
      <th [attr.colspan]="innerWidth < 1200 ? 3 : 2">
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="pi pi-search"></i>
          </p-inputgroup-addon>
          <input
            type="text"
            pInputText
            (input)="onGlobalFilter(dt1, $event)"
            placeholder="{{ 'search' | transloco }}"
          />
        </p-inputgroup>
      </th>
      <th class="d-none d-xl-table-cell"></th>
    </tr>
    <tr>
      <th pSortableColumn="name" class="col-6">
        {{ "name" | transloco }} <p-sortIcon field="name"></p-sortIcon>
      </th>
      <th pSortableColumn="createdAt" class="col-5">
        {{ "created" | transloco }} <p-sortIcon field="createdAt"></p-sortIcon>
      </th>
      <th class="col-1"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-tenant>
    <tr>
      <td>
        <div class="d-flex align-items-center">
          <app-entity-avatar
            [img]=""
            [alt]="tenant.name"
            icon="bi-building"
          ></app-entity-avatar>
          <p>
            <span
              class="txt-name text-break ms-1"
              [routerLink]="['/tenants', tenant.id]"
              >{{ tenant.name }}</span
            >
            <br />
            <small>
              <span class="txt-sub text-break ms-1">
                {tenant.countOfUsers, plural, =1 {1 user} other
                {{{tenant.countOfUsers}} users}}</span
              >
            </small>
          </p>
        </div>
      </td>
      <td>{{ tenant.createdAt | date : "dd-MM-yyyy hh:mm" }}</td>

      <td>
        <div
          *ngIf="auth.isAnyAdmin$ | async"
          class="d-flex justify-content-end"
        >
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            tabindex="-1"
            class="small-icon-button d-flex justify-content-center align-items-center p-0"
            style="width: 32px; height: 32px; font-size: 20px; line-height: 1"
          >
            <img src="assets/img/dots-vertical.svg" alt="Menu Icon" />
          </button>

          <mat-menu #menu="matMenu" xPosition="before">
            <button mat-menu-item [routerLink]="['/tenants/html', tenant.id]">
              {{ "home" | transloco }}
            </button>
            <button mat-menu-item [routerLink]="['/tenants/info', tenant.id]">
              {{ "info" | transloco }}
            </button>
            <button mat-menu-item [routerLink]="['/tenants', tenant.id]">
              {{ "edit" | transloco }}
            </button>
            <button
              mat-menu-item
              [routerLink]="['/tenants/description', tenant.id]"
            >
              {{ "description" | transloco }}
            </button>
            <button mat-menu-item [routerLink]="['/tenants/tags', tenant.id]">
              {{ "tags" | transloco }}
            </button>
            <button
              mat-menu-item
              [routerLink]="['/tenants/folders', tenant.id]"
            >
              {{ "folders" | transloco }}
            </button>
            <button mat-menu-item [routerLink]="['/tenants/teams', tenant.id]">
              {{ "teams" | transloco }}
            </button>
            <button
              mat-menu-item
              [routerLink]="['/tenants/departments', tenant.id]"
            >
              {{ "departments" | transloco }}
            </button>
            <button
              mat-menu-item
              [routerLink]="['/tenants/checklists', tenant.id]"
            >
              {{ "checklists" | transloco }}
            </button>
            <button mat-menu-item [routerLink]="['/deleting', tenant.id]">
              {{ "delete" | transloco }}
            </button>
            <button mat-menu-item [routerLink]="['/tenants/emails', tenant.id]">
              {{ "msGraphOptions" | transloco }}
            </button>
            <button
              mat-menu-item
              (click)="cloneConfirmation = tenant"
              data-bs-target="#cloneusermodal"
            >
              {{ "clone" | transloco }}
            </button>
            <button
              mat-menu-item
              [routerLink]="['/tenants/emailtemplate', tenant.id]"
            >
              {{ "emailTemplates" | transloco }}
            </button>
            <!-- <button
              mat-menu-item
              (click)="deleteConfirmation = tenant"
              data-bs-target="#deleteusermodal"
              class="text-danger"
            >
              {{ "delete" | transloco }}
            </button> -->
          </mat-menu>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<app-confirm-delete
  id="deleteusermodal"
  *ngIf="deleteConfirmation"
  [deleteCandidate]="deleteConfirmation.name"
  (confirm)="handleDeleteClick(deleteConfirmation); deleteConfirmation = null"
  (cancel)="deleteConfirmation = null"
></app-confirm-delete>

<app-clone-pop-up
  id="cloneusermodal"
  *ngIf="cloneConfirmation"
  [cloneCandidateId]="cloneConfirmation.id"
  [cloneCandidateName]="cloneConfirmation.name"
  [withUsergroups]="false"
  [hideTenantOptionsSelector]="true"
  (confirm)="clone.emit($event); cloneConfirmation = null"
  (cancel)="cloneConfirmation = null"
></app-clone-pop-up>
